export default __webpack_public_path__ + "static/media/ex.e2d5cac9.svg";